import { render, staticRenderFns } from "./OrganogramFlow.vue?vue&type=template&id=1a86ec00&scoped=true&"
import script from "./OrganogramFlow.vue?vue&type=script&lang=js&"
export * from "./OrganogramFlow.vue?vue&type=script&lang=js&"
import style0 from "./OrganogramFlow.vue?vue&type=style&index=0&id=1a86ec00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a86ec00",
  null
  
)

export default component.exports